module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontmatter",
    attrs: {
      "title": "The Big Book of Gross Stuff"
    }
  }, [_c('div', {
    staticClass: "verso"
  }, [_c('p', {
    staticClass: "versotitle"
  }, [_vm._v("The Big Book of Gross Stuff")]), _vm._v(" "), _c('p', [_vm._v("Digital Edition v1.0")]), _vm._v(" "), _c('p', [_vm._v("Text © 2010 Bart King")]), _vm._v(" "), _c('p', [_vm._v("Illustrations © 2010 Russell Miller")]), _vm._v(" "), _c('p', [_vm._v("All rights reserved. No part of this book may be reproduced by any means\n                    whatsoever without written permission from the publisher, except brief portions\n                    quoted for purpose of review.")]), _vm._v(" "), _c('p', {
    staticClass: "nobreak"
  }, [_vm._v("Gibbs Smith, Publisher")]), _vm._v(" "), _c('p', {
    staticClass: "nobreak"
  }, [_vm._v("PO Box 667")]), _vm._v(" "), _c('p', [_vm._v("Layton, UT 84041")]), _vm._v(" "), _c('p', {
    staticClass: "nobreak"
  }, [_vm._v("Orders: 1.800.835.4993")]), _vm._v(" "), _c('p', [_vm._v("www.gibbs-smith.com")]), _vm._v(" "), _c('p', [_vm._v("Library of Congress Catalog-in-Publishing Data")]), _vm._v(" "), _c('p', {
    staticClass: "nobreak"
  }, [_vm._v("ISBN-13:978-1-4236-0746-5")]), _vm._v(" "), _c('p', {
    staticClass: "nobreak"
  }, [_vm._v("ISBN-10: 1-4236-0746-5")]), _vm._v(" "), _c('p', {
    staticClass: "nobreak"
  }, [_vm._v("1. Curiosities and wonders—Humor. 2. Human\n                    body—Miscellanea—Humor. 3. Hygiene—Humor. 4. Conduct of life—Miscellanea—Humor.\n                    I. Miller, Russell. II. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "nobreak"
  }, [_vm._v("PN6231.C85K56 2010")]), _vm._v(" "), _c('p', {
    staticClass: "nobreak"
  }, [_vm._v("818’.607—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "nobreak"
  }, [_vm._v("2009035220")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e86403d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/verso.vue
// module id = 60
// module chunks = 0